import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useTour } from '@orion.ui/orion';

type Props = SetupProps<typeof TourQrCodeSetupService.props>

export default class TourQrCodeSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _tourQrCode = ref<OrionTour>();

	private readonly state = reactive({ hasData: false });

	get hasData () { return this.state.hasData; }

	constructor () {
		super();
	}

	protected onMounted () {
		super.onMounted();

		useTour('tourQrCode', this._tourQrCode.value);
		this.registerBusEvent('companies-loaded', (hasData) => {
			this.state.hasData = hasData;
		});
	}

	showQrIconOnHover () {
		return {
			callback: () => {
				return new Promise((resolve) => {
					const sticker = document.getElementsByClassName('company-el')[0];
					(sticker.getElementsByClassName('orion-sticker__actions')[0] as HTMLElement).style.opacity = '1';
					setTimeout(() => {
						resolve(true);
					}, 250);
				});
			},
			label: 'Suivant',
		};
	}

	removeHover () {
		return {
			callback: () => {
				const sticker = document.getElementsByClassName('company-el')[0];
				(sticker.getElementsByClassName('orion-sticker__actions')[0] as HTMLElement).style.opacity = '';
				return;
			},
			label: 'Terminer',
		};
	}
}
